import { render } from "./GastosPorMes.vue?vue&type=template&id=364a79d0&scoped=true"
import script from "./GastosPorMes.vue?vue&type=script&lang=js"
export * from "./GastosPorMes.vue?vue&type=script&lang=js"

import "./GastosPorMes.vue?vue&type=style&index=0&id=364a79d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-364a79d0"]])

export default __exports__